// Helpers for normalising rich-text (TinyMCE) chapter content before it is saved,
// previewed or loaded back into the editor. Kept framework-free so it can be shared
// between the editor component and the authoring-tool modal.

// Characters that look empty to the user but survive String.trim()
// (nbsp, zero-width space/non-joiner/joiner, BOM).
const INVISIBLE_CHARS = /[\u00a0\u200b\u200c\u200d\ufeff]/g;

// True when a node carries no visible content of its own: whitespace/invisible text,
// a <br>, or an empty <p>/<div>. Media (and anything wrapping it) is never "empty".
function isTrailingEmpty (node) {
    if (!node) return false;
    if (node.nodeType === 3) return node.textContent.replace(INVISIBLE_CHARS, '').trim() === '';
    if (node.nodeType !== 1) return false;
    if (node.tagName === 'BR') return true;
    if (!['P', 'DIV'].includes(node.tagName)) return false;
    if (node.querySelector('img, iframe, video, embed, figure, table, hr')) return false;

    return node.textContent.replace(INVISIBLE_CHARS, '').trim() === '';
}

// Removes empty lines (blank paragraphs/divs, <br>, whitespace) from the end of the
// content so saving/previewing doesn't keep trailing blank lines. Non-empty content
// and media are kept.
export function stripTrailingEmptyParagraphs (html) {
    if (!html) return html;

    const body = new DOMParser().parseFromString(html, 'text/html').body;

    while (body.lastChild && isTrailingEmpty(body.lastChild)) {
        body.removeChild(body.lastChild);
    }

    return body.innerHTML;
}



// WEBPACK FOOTER //
// ./src/app/services/htmlContent/index.js